// removed by extract-text-webpack-plugin
module.exports = {"snackbar":"zDi3XsbYW9cAJ7MwpAt2h","accept":"_2Y0Cy8oP5ZEm3BlgrM8kAD","button":"_2pCxUK6riOrQq5AdtkuF04","warning":"_2li3ofmpUeVtfhggEF5INI","cancel":"_3731C_Vt8sggS3BXCcaVNO","active":"_38CsOo83QlFyoqETbqNXmT","label":"_1JIbYbZDMG2nJ2kBoxL46-"};


//////////////////
// WEBPACK FOOTER
// ./~/react-toolbox/lib/snackbar/theme.css
// module id = 1047
// module chunks = 0